import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslationService } from '../../../shared/translation.service';

@Component({
  selector: 'lp2-mini-lesson-tile-complete',
  templateUrl: './mini-lesson-tile-complete.component.html',
  styleUrls: ['./mini-lesson-tile-complete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniLessonTileCompleteComponent {
  constructor(private translationService: TranslationService) {}

  clickHereMessage = this.translationService.translate('studybundle.lessons.goToUnitIndex', {here: this.translationService.translate('activation.student_info.errors.phone_number.valid.here')});
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-tile-complete/mini-lesson-tile-complete.component.ts